import { Select, styled } from "@mui/material";

export const InputWrapper = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  height: 40,
  alignItems: "center"
}))

export const InputLabel = styled('label')(({ theme }) => ({
  fontWeight: 600,
  fontSize: 12
}))

export const InputComponent = styled('input')(({ theme }) => ({
  flexBasis: 280,
  background: "#2C3748",
  borderRadius: 5,
  height: 30,
  color: "white",
  fontFamily: theme.typography.fontFamily,
  outline: "none",
  paddingLeft: theme.spacing(1.2),
  fontSize: 12,
  border: `1px solid transparent`,
  fontWeight: 400,
  ":focus": {
    borderColor: theme.palette.primary.dark
  }
}))

export const SelectComponent = styled(Select)(({ theme }) => ({
  height: 28,
  backgroundColor: "#2C3748",
  flexBasis: 280,
  borderRadius: 5,
  "&>div": {
    paddingTop: 8,
    paddingBottom: 8,
  },

  "fieldset": {
    border: "none"
  }
}))